import { render, staticRenderFns } from "./GestioneSamm.vue?vue&type=template&id=401bd529&"
import script from "./GestioneSamm.vue?vue&type=script&lang=js&"
export * from "./GestioneSamm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./modules/Home/views/src/pages/GestioneSamm.vue
// module id = 915
// module chunks = 0